const CARD_VALUES = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];
const CARD_SUITS = ["s", "h", "d", "c"];

export const ACTIONS = {
  check: "Check",
  bet: "Bet",
  call: "Call",
  fold: "Fold",
};

export const HANDTYPES = [
  "invalid hand",
  "high card",
  "one pair",
  "two pairs",
  "three of a kind",
  "straight",
  "flush",
  "full house",
  "four of a kind",
  "straight flush",
];

const COLOR_SCHEMES = {
  default: {
    id: "default",
    label: "Default",
    colors: ["#ff5050", "#2828d7", "#00a000", "#4d4d4d"],
  },
  redBook: {
    id: "redBook",
    label: "Red Book",
    colors: ["#ff1513", "#ffa4a4", "#000000", "#818181"],
  },
};

const RANGEGROUP_TYPES = {
  preflop: {
    id: "preflop",
    label: "Preflop",
    colorScheme: "default",
    subranges: [
      {
        label: "Raise",
        action: ACTIONS.bet,
      },
      {
        label: "Call",
        action: ACTIONS.call,
      },
      {
        label: null,
        action: null,
      },
      {
        label: "Fold",
        action: ACTIONS.fold,
      },
    ],
  },
  preflopPolar: {
    id: "preflopPolar",
    label: "Preflop Polar",
    colorScheme: "default",
    subranges: [
      {
        label: "3-bet for Value",
        action: ACTIONS.bet,
      },
      {
        label: "3-bet as a Bluff",
        action: ACTIONS.bet,
      },
      {
        label: "Call",
        action: ACTIONS.call,
      },
      {
        label: "Fold",
        action: ACTIONS.fold,
      },
    ],
  },
  preflopLinear: {
    id: "preflopLinear",
    label: "Preflop Linear",
    colorScheme: "default",
    subranges: [
      {
        label: "3-bet for Value",
        action: ACTIONS.bet,
      },
      {
        label: "3-bet for Lesser Value",
        action: ACTIONS.bet,
      },
      {
        label: "Call",
        action: ACTIONS.call,
      },
      {
        label: "Fold",
        action: ACTIONS.fold,
      },
    ],
  },
  postflopAggressor: {
    id: "postflopAggressor",
    label: "Postflop Aggressor",
    colorScheme: "default",
    subranges: [
      {
        label: "Premium Made (Bet)",
        action: ACTIONS.bet,
      },
      {
        label: "Draw (Bet)",
        action: ACTIONS.bet,
      },
      {
        label: "Marginal Made (Check)",
        action: ACTIONS.check,
      },
      {
        label: "Junk (Check)",
        action: ACTIONS.check,
      },
    ],
  },
  postflopCaller: {
    id: "postflopCaller",
    label: "Postflop Caller",
    colorScheme: "default",
    subranges: [
      {
        label: "Premium Made (Raise)",
        action: ACTIONS.bet,
      },
      {
        label: "Draw (Raise)",
        action: ACTIONS.bet,
      },
      {
        label: "Marginal Made (Call)",
        action: ACTIONS.call,
      },
      {
        label: "Junk (Fold)",
        action: ACTIONS.fold,
      },
    ],
  },
};

export { CARD_VALUES, CARD_SUITS, COLOR_SCHEMES, RANGEGROUP_TYPES };
